import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import * as ElIconModules from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import axios from './http'

const app = createApp(App)
app.config.globalProperties.$axios = axios

for (const iconName in ElIconModules) {
    if (Reflect.has(ElIconModules, iconName)) {
        const item = ElIconModules[iconName as keyof typeof ElIconModules]
        app.component(iconName, item)
    }
}

app
    .use(store)
    .use(router)
    .use(ElementPlus)
    .mount('#app')

